import React from 'react';
import { Text, Tooltip, Bubble } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';

/**
 * @param product
 * @param productPlanData
 * @param language
 * @returns {JSX.Element}
 * @private
 */
const _buildCoverageBlock = (product, productPlanData, language) => {
  const lines = [];
  for (const item of product.coverageOverview) {
    // check to see if the line should be displayed or not based on the display clause
    if (item.displayClause && item.displayClause.value !== productPlanData[item.displayClause.dataFieldLabel]) {
      // eslint-disable-next-line no-continue
      continue;
    }
    let text = item.text[language];

    // if the text has params then lets replace them with their correct values
    if (item.paramsMap) {
      for (let i = 0; i < item.paramsMap.length; i++) {
        const paramsData = item.paramsMap[i];
        let value = productPlanData[paramsData.dataFieldLabel];
        if (paramsData.type === 'dollar') {
          value = `$${helpers.formatNumber(value, paramsData.decimalPlaces || 0, false)}`;
        }
        text = text.replace(`params[${i}]`, value);
      }
    }
    lines.push(text);
  }
  return /*#__PURE__*/React.createElement("div", null, lines.map(line => /*#__PURE__*/React.createElement(Text, {
    small: true
  }, line)));
};

/**
 * @param data
 * @param specialityProductMetaConfigs
 * @param language
 * @returns {JSX.Element}
 * @constructor
 */
const SpecialityProductsBlock = ({
  data,
  specialityProductMetaConfigs,
  language
}) => {
  const styles = {
    rowContainer: {
      padding: "10px 0"
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, data.map(classData => /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "10px 20px"
    }
  }, /*#__PURE__*/React.createElement(Tooltip, {
    tip: classData.classDescription,
    placement: "top",
    arrow: true,
    display: "inline-block",
    key: classData.title
  }, /*#__PURE__*/React.createElement(Bubble, {
    isSelected: true,
    label: `Class: ${classData.classTitle}`
  })), /*#__PURE__*/React.createElement("div", null, Object.keys(classData.coverage).map(specialityProductID => {
    const productCoverage = classData.coverage[specialityProductID];
    const privateLabelID = productCoverage.privateLabelID;
    const privateLabelProducts = specialityProductMetaConfigs[privateLabelID].products;
    const productData = privateLabelProducts[specialityProductID];
    const productPlanData = classData.coverage[specialityProductID];
    if (!productPlanData.isSelected) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      key: specialityProductID
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.rowContainer
    }, /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      bold: true,
      margin: "0 0 5px 0"
    }, `${productData.name} (${productData.carrier})`), _buildCoverageBlock(productData, productPlanData, language)));
  })))));
};
export default SpecialityProductsBlock;